import { Component } from '@angular/core';
import { OrderDetailTotalsComponent } from '@spartacus/order/components';
import { EfaOrderSummaryComponent } from '../../../shared/components/efa-order-summary/efa-order-summary.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-order-detail-totals',
    templateUrl: './efa-order-detail-totals.component.html',
    imports: [EfaOrderSummaryComponent, AsyncPipe]
})
export class EfaOrderDetailTotalsComponent extends OrderDetailTotalsComponent {
}
